module.exports = __webpack_public_path__ + "static/media/cifraoAzul.612fbd78.svg";